import * as Tooltip$1 from '@radix-ui/react-tooltip';
import { TooltipContent, TooltipArrow } from './styled.js';
import { jsxs, jsx } from 'react/jsx-runtime';

/*
 * Tooltip component provides additional information when hovering over or focusing on an element.
 * see https://www.radix-ui.com/docs/primitives/components/tooltip
 */
function Tooltip(props) {
  var children = props.children,
    title = props.title,
    width = props.width,
    _props$delay = props.delay,
    delay = _props$delay === void 0 ? 500 : _props$delay,
    side = props.side,
    disabled = props.disabled,
    ariaLabel = props['aria-label'];
  if (disabled) {
    return children;
  }
  return /*#__PURE__*/jsxs(Tooltip$1.Root, {
    delayDuration: delay,
    children: [/*#__PURE__*/jsx(Tooltip$1.Trigger, {
      asChild: true,
      children: children
    }), /*#__PURE__*/jsx(Tooltip$1.Portal, {
      children: /*#__PURE__*/jsxs(TooltipContent, {
        sideOffset: 5,
        side: side,
        $width: width,
        "aria-label": ariaLabel,
        children: [title, /*#__PURE__*/jsx(TooltipArrow, {})]
      })
    })]
  });
}

export { Tooltip };
